import { MessageType } from './message-type';
import { SnackbarVariant } from '@eas/common-web';

const COPY: MessageType<'SUCCESS'> = {
  SUCCESS: ['Odkaz úspěšně zkopírován.', SnackbarVariant.SUCCESS],
};

export default { COPY };
